import { useState, useEffect } from 'react';
import { getRevenueAnalytics } from '../../services/revenueService';
import LineChart from '../charts/LineChart';
import PieChart from '../charts/PieChart';

const RevenueTab: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [revenueData, setRevenueData] = useState<any>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getRevenueAnalytics(30);
        setRevenueData(data);
      } catch (error) {
        console.error('Error loading revenue data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading revenue data...</p>
      </div>
    );
  }

  if (!revenueData) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>No revenue data available</p>
      </div>
    );
  }

  const platformData = {
    labels: ['Stripe', 'iOS', 'Android'],
    datasets: [
      {
        label: 'Revenue by Platform',
        data: [
          revenueData.revenueByPlatform.stripe,
          revenueData.revenueByPlatform.ios,
          revenueData.revenueByPlatform.android,
        ],
        backgroundColor: ['#2563eb', '#10b981', '#f59e0b'],
      },
    ],
  };

  const dailyRevenueData = {
    labels: revenueData.revenueByPeriod.daily.map((d: any) => d.date),
    datasets: [
      {
        label: 'Daily Revenue',
        data: revenueData.revenueByPeriod.daily.map((d: any) => d.revenue),
        borderColor: '#2563eb',
        backgroundColor: 'rgba(37, 99, 235, 0.1)',
        fill: true,
      },
    ],
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ marginBottom: '2rem', fontSize: '1.75rem', fontWeight: 'bold' }}>
        Revenue Analytics
      </h1>

      {/* KPI Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem',
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}>
          <p style={{ margin: 0, color: '#666', fontSize: '0.875rem' }}>Total Revenue</p>
          <h2 style={{ margin: '0.5rem 0', fontSize: '2rem', fontWeight: 'bold' }}>
            ${revenueData.totalRevenue.toFixed(2)}
          </h2>
        </div>
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}>
          <p style={{ margin: 0, color: '#666', fontSize: '0.875rem' }}>ARPU</p>
          <h2 style={{ margin: '0.5rem 0', fontSize: '2rem', fontWeight: 'bold' }}>
            ${revenueData.averageRevenuePerUser.toFixed(2)}
          </h2>
        </div>
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}>
          <p style={{ margin: 0, color: '#666', fontSize: '0.875rem' }}>LTV</p>
          <h2 style={{ margin: '0.5rem 0', fontSize: '2rem', fontWeight: 'bold' }}>
            ${revenueData.lifetimeValue.toFixed(2)}
          </h2>
        </div>
      </div>

      {/* Charts */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem',
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}>
          <h3 style={{ marginTop: 0 }}>Revenue by Platform</h3>
          <PieChart data={platformData} height={300} />
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}>
          <h3 style={{ marginTop: 0 }}>Daily Revenue Trend</h3>
          <LineChart data={dailyRevenueData} height={300} />
        </div>
      </div>
    </div>
  );
};

export default RevenueTab;

